module.exports = __webpack_public_path__ + "img/Michelle_Kim.30c5ac67.jpg";